export default __webpack_public_path__ + "static/goway-travel-cappadocia-turkey-30d64813e231c93148c0a56d84382c0a.webp";